import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
const Root = styled.article `
  box-sizing: border-box;
  background-color: ${theme.semantic.surface.primary};
  color: ${theme.semantic.foreground.secondary};

  h1,
  h2,
  h3,
  h4 {
    font-weight: ${theme.fontWeight.semibold};
    line-height: ${theme.lineHeight.neutralized};
  }

  h1 {
    font-size: 1.75rem;
    margin-bottom: ${theme.spacing['2xl']};
  }

  h2 {
    font-size: ${theme.fontSize.display};
    margin-bottom: ${theme.spacing['2xl']};
  }

  h3 {
    font-size: ${theme.fontSize.large};
  }

  h4 {
    font-size: ${theme.fontSize.medium};
  }

  ol,
  ul {
    margin-left: ${theme.spacing['2xl']};
    list-style: none;

    li[data-visibility='hidden'] {
      display: none;
    }
  }

  ul {
    li[data-visibility='visible']::before {
      margin-right: ${theme.spacing.md};
      vertical-align: middle;
      font-family: sans-serif;
      float: left;
      content: '\u25E6';
    }
  }

  hr {
    width: 100%;
    height: ${theme.spacing.xs};
    border: 0;
    background-color: ${theme.semantic.surface.sunken};
  }

  ol {
    counter-reset: item;

    > li:not(:empty) {
      margin-top: ${theme.spacing.xl};
      counter-increment: item;

      &::before {
        margin-right: ${theme.spacing.md};
        vertical-align: bottom;
        float: left;
        content: counters(item, '.') '.';
      }
    }

    > li > ol > li:not(:empty)::before {
      content: counter(item, lower-alpha) ')';
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
  }

  th,
  td {
    margin: 0;
    border: ${pxToRem(1)} solid ${theme.swatches.gray[800]};
    padding: ${theme.spacing.xl};
    width: 50%;
  }
`;
export default Root;
